export default __webpack_public_path__ + "static/modal-dont-light-1f14cedd00d075d41450ccf4107e4ef12cfe60bf9c8f992e0bb84de9d2a08a53.png";